import './login.css';
import { Header } from "../../components/header/Header";
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { BarLoader } from '../../components/BarLoader/BarLoader';
import { useAuth } from '../../context/AuthContext';
import { useLang } from '../../context/LangContext';

export function Login() {
    const navigate = useNavigate();
    const { login, checkAuth } = useAuth();
    const { lang } = useLang();

    //STATES
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState("");
    const [email, setEmail] = useState("");
    const [pwd, setPwd] = useState("");


    //FUNCTIONS
    const postLogin = () => {
        if (loading) {
            return;
        }

        setErrorMsg("");
        setLoading(true);

        login(email, pwd, (res) => {
            setLoading(false);
            
            if (res[0]) {
                res = res[1];

                if (res.success) {
                    checkAuth();
                    navigate('/courses', {replace: true});
                } else {
                    if (res.error === "incorrect_credentials") {
                        setErrorMsg(lang === "en" ? "Email or password wrong" : "Correo o contraseña incorrectos");
                    }

                    if (res.error === "required_field") {
                        setErrorMsg(lang === "en" ? "All fields are required" : "Todos los campos son requeridos");
                    }
                }
            } else {
                setErrorMsg(lang === "en" ? "Server error, please try again in a bit": "Error del servidor, intenta de nuevo en un momento");
            }
        });
    }

    return (
        <>
            <Header />
            <div className="login_form_body">
                <div className='form'>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Email" : "Correo electrónico" }
                        </label>
                        <input type='text' placeholder={ lang === "en" ? "Email" : "Correo electrónico" } value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Password" : "Contraseña" }
                        </label>
                        <input type='password' placeholder={ lang === "en" ? "Password" : "Contraseña" } value={pwd} onChange={(e) => setPwd(e.target.value)} />
                    </div>
                    {errorMsg !== "" && 
                        (
                            <div className='error_msg'>
                                {errorMsg}
                            </div>
                        )
                    }
                    <button onClick={postLogin}>
                        { lang === "en" ? "Login" : "Iniciar sesión" }
                    </button>
                    {loading && 
                        (
                            <div className='loader'>
                                <BarLoader />
                            </div>
                        )
                    }
                    <Link to='/register'>
                        { lang === "en" ? "Don't have an account? Sign up" : "¿No tienes una cuenta? Registrate" }
                    </Link>
                    <Link to='/forgot'>
                        { lang === "en" ? "Forgot your password?" : "¿Olvidaste tu contraseña?" }
                    </Link>
                </div>
            </div>
        </>
    );
}